import type { EstimateHistoryPoint, EvidenceBalance } from "../types";
import { ProbabilityHistoryChart } from "./ProbabilityHistoryChart";

export function FeaturedHistoryChart({ history, currentEvidenceBalance }: { history: EstimateHistoryPoint[]; currentEvidenceBalance?: EvidenceBalance | null }) {
  return <ProbabilityHistoryChart history={history} currentEvidenceBalance={currentEvidenceBalance} variant="homepage" />;
}
